import React from "react";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { DateField } from "../../../../../../features/forms/fields/date-field/date-field.component";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

export const CbTemplateControlWarehouseEta = (props: CbTemplateControlProps) => (
  <BorderedBlock>
    <DateField
      form={props.form}
      label="ETA product in warehouse"
      name="warehouseEta"
      userPermissions={props.userPermissions}
    />
  </BorderedBlock>
);
